

<router-outlet></router-outlet>
<ngx-loading [show]="showLoader" [config]="{ backdropBorderRadius: '3px'}" ></ngx-loading>

<!-- <div class="my-container">
    <ng-template #customLoadingTemplate>
        <div class="custom-class">
            <h3>
               Uploading. Please Wait...
            </h3>
          
        </div>
    </ng-template>
</div> -->